import { render } from "./GerenciamentoGrupos.vue?vue&type=template&id=85846aba&scoped=true"
import script from "./GerenciamentoGrupos.vue?vue&type=script&lang=js"
export * from "./GerenciamentoGrupos.vue?vue&type=script&lang=js"

import "./GerenciamentoGrupos.vue?vue&type=style&index=0&id=85846aba&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85846aba"]])

export default __exports__